import { useState } from "react";
import { useNavigate } from "react-router-dom";

// material-ui
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

// assets
import LogoutOutlined from "@ant-design/icons/LogoutOutlined";
import { EditOutlined } from "@ant-design/icons";
import { LockOutlined } from "@ant-design/icons";

interface Props {
  handleLogout: () => void;
  handleToggle: () => void;
}

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ handleLogout, handleToggle }: Props) {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement>,
    index: number,
    route: string = ""
  ) => {
    setSelectedIndex(index);

    if (route && route !== "") {
      navigate(route);
    }
  };

  return (
    <List
      component="nav"
      sx={{ p: 0, "& .MuiListItemIcon-root": { minWidth: 32 } }}
    >
      <ListItemButton selected={selectedIndex === 3}>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText
          primary="Edit Profile"
          onClick={function () {
            navigate("security/user/editProfile");
            handleToggle();
          }}
        />
      </ListItemButton>
      <ListItemButton selected={selectedIndex === 1}>
        <ListItemIcon>
          <LockOutlined />
        </ListItemIcon>
        <ListItemText
          primary="Change Password"
          onClick={function () {
            navigate("security/user/change-password");
            handleToggle();
          }}
        />
      </ListItemButton>
      <ListItemButton selected={selectedIndex === 2} onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </List>
  );
}
